import { faArrowUpArrowDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import theme from '~/theme/';

type SortIconProps = {
  fieldName?: string;
  sortable?: boolean;
  gridSort?: {
    field?: string;
    direction?: string;
    icon?: any;
  };
  isReadOnlyUrl?: boolean;
};

export const SortIcon = ({
  fieldName,
  sortable,
  gridSort,
  isReadOnlyUrl,
}: Readonly<SortIconProps>) => {
  if (typeof sortable !== 'boolean' || sortable) {
    if (fieldName === gridSort.field) {
      return (
        <FontAwesomeIcon
          icon={gridSort.icon}
          data-testid={`sort-icon-${gridSort.direction}`}
          style={{
            color: isReadOnlyUrl ? theme.colors?.black : theme.colors?.white,
          }}
        />
      );
    } else {
      return (
        <FontAwesomeIcon
          icon={faArrowUpArrowDown}
          data-testid={`sort-icon`}
          style={{
            color: isReadOnlyUrl ? theme.colors?.black : theme.colors?.white,
          }}
        />
      );
    }
  }
  return <div data-testid="no-sort-icon"></div>;
};
